import React from 'react';
import { useTranslation } from 'react-i18next';

interface ExpandChevronProps {
  isExpanded: boolean;
  rowId: string;
  disabled: boolean;
  fnCallback?: () => void;
}

const ExpandChevron = (props: ExpandChevronProps) => {
  const { t } = useTranslation('common');
  return (
    <button
      type="button"
      className="btn btn-link btn-no-hover flex-table-collapse-control"
      title={props.isExpanded ? t('blazeTable.closeDetails') : t('blazeTable.openDetails')}
      aria-expanded={props.isExpanded}
      id={'expanderButton-' + props.rowId}
      onClick={props.fnCallback}
      disabled={props.disabled}
    >
      <span
        className={props.isExpanded ? 'icon-bzm-chevron-down icon-sm' : 'icon-bzm-chevron-right icon-sm'}
        aria-hidden="true"
      />
      <span className="sr-only">{t('blazeTable.itemDetails')}</span>
    </button>
  );
};

export default ExpandChevron;
